import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { isElectronContext } from 'motion-master-client';

import { BrandService } from '@app/services/brand.service';
import { GlobalService } from '@app/services/global.service';

@Component({
  selector: 'app-release-info',
  templateUrl: './release-info.component.html',
  imports: [AsyncPipe, NgTemplateOutlet],
})
export class ReleaseInfoComponent implements OnInit {
  private brandService = inject(BrandService);
  private globalService = inject(GlobalService);

  motionMasterVersion$ = this.globalService.motionMasterVersion$;
  matchingRelease$ = this.globalService.matchingRelease$;
  newerLatestProductionRelease$ = this.globalService.newerLatestProductionRelease$;
  isOblacDrivesBrand$ = this.brandService.isOblacDrivesBrand$;
  isElectronApp = false;

  ngOnInit() {
    this.isElectronApp = isElectronContext();
  }
}
